import Cliser from "cliser";
import Checkbox from "components/Checkbox";
import ImageData from "components/ImageData";
import React from "react";
import Utils from "utils";

require("style/GaugeCanvas"); // share same style with GaugeCanvas

export default class Camera extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rotate: 0,
    };
  }

  componentDidMount() {
    this.updateCanvas();
  }

  componentDidUpdate() {
    this.updateCanvas();
  }

  componentWillReceiveProps(props) {
    if (
      !this.props.image ||
      !props.image ||
      this.props.image.timestamp !== props.image.timestamp
    ) {
      this.setState({ rotate: 0 });
    }
  }

  onMouseDown(evt) {
    if (this.state.horizonCorrectionEnabled) {
      const pos = Utils.getEventXY(evt, this.refs.canvas);
      this.setState({ levelLine: { from: pos, to: pos } });
    }
  }

  onMouseMove(evt) {
    let line = this.state.levelLine;
    if (line) {
      this.setState({
        levelLine: Object.assign(line, {
          to: Utils.getEventXY(evt, this.refs.canvas),
        }),
      });
    }
  }

  onMouseUp(evt) {
    let line = this.state.levelLine;
    if (line) {
      let angle = Utils.angleBetweenLines(
        line.from.x,
        line.from.y,
        line.to.x,
        line.to.y,
        0,
        0,
        1,
        0
      );
      this.props.onRotationChange(
        Utils.toFixed(
          Utils.adjustBetweenValues(
            parseFloat(this.props.settings.orientation - angle),
            -180,
            180
          ),
          1
        )
      );
      this.setState({
        levelLine: null,
        rotate: this.state.rotate - (angle / 180) * Math.PI,
      });
    }
  }
  downloadimage() {
    return Cliser.ImageModel.getImageData().then((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      }).then((image) => {
        var download = document.getElementById("download");
        console.log(download);
        download.setAttribute("href", image);
        download.click();
      });
    });
  }

  updateCanvas() {
    let canvas = this.refs.canvas;
    if (canvas) {
      let ctx = canvas.getContext("2d");
      ctx.save();
      ctx.fillStyle = "#f8f8f8";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      if (this.props.image && this.props.image.canvas) {
        let image = this.props.image.canvas;
        canvas.width = image.width;
        canvas.height = image.height;

        ctx.save();
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(this.state.rotate);
        ctx.drawImage(image, -canvas.width / 2, -canvas.height / 2);
        ctx.restore();

        if (this.props.grid) {
          ctx.save();
          ctx.translate(0.5, 0.5);
          ctx.strokeStyle = "rgba(0, 0, 0, 0.3)";
          ctx.beginPath();
          for (let x = 0; x < canvas.width; x += 50) {
            ctx.moveTo(x, 0);
            ctx.lineTo(x, canvas.height);
          }
          for (let y = 0; y < canvas.height; y += 50) {
            ctx.moveTo(0, y);
            ctx.lineTo(canvas.width, y);
          }
          ctx.stroke();
          ctx.restore();
        }

        if (this.state.levelLine) {
          const line = this.state.levelLine;
          ctx.save();
          ctx.globalCompositeOperation = "difference";
          ctx.strokeStyle = "white";
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.moveTo(line.from.x, line.from.y);
          ctx.lineTo(line.to.x, line.to.y);
          ctx.stroke();
          ctx.restore();
        }
      }
      ctx.restore();
    }
  }

  render() {
    if (this.props.message || !this.props.image) {
      return (
        <div className="GaugeCanvas">
          <div className="loader">{this.props.message || "No image"}</div>
        </div>
      );
    }
    return (
      <div className="Camera">
        <canvas
          ref="canvas"
          onMouseDown={this.onMouseDown.bind(this)}
          onMouseMove={this.onMouseMove.bind(this)}
          onMouseUp={this.onMouseUp.bind(this)}
        />
        <ImageData {...this.props.image} tab={this.props.tab}>
          {this.props.onRotationChange && this.props.image && (
            <div style={{ marginTop: "50px" }}>
              {
                <Checkbox
                  label="Enable horizon correction tool"
                  checked={this.state.horizonCorrectionEnabled}
                  onChange={() =>
                    this.setState({
                      horizonCorrectionEnabled:
                        !this.state.horizonCorrectionEnabled,
                    })
                  }
                />
              }
              {/* TODO this text breaks image
                this.state.horizonCorrectionEnabled &&
                <p>Adjust rotation by marking the horizon with mouse.</p>
              */}
              {this.props.note && (
                <div className="post-it">{this.props.note}</div>
              )}
              {(this.props.openServiceRequests && this.props.openServiceRequests.length > 0) && (
                <div className="post-it">
                  <div><i>Open service requests:</i></div>
                  {this.props.openServiceRequests.map((s) => (<div>
                      <div><b>{s.Case_Category_Specification__c}</b></div>
                      <div>{s.Description}</div>
                      <div>{s.CreatedDate}</div>
                    </div>))}
                </div>
              )}
              <div>
                <div>
                  <button
                    type="button"
                    onClick={() => this.props.onAutoConfig()}
                  >
                    Auto Config
                  </button>
                </div>
                <div>
                  <a id="download" download="image.png">
                    <button
                      type="button"
                      className="downloadButton"
                      onClick={() => this.downloadimage()}
                    >
                      Download image
                    </button>
                  </a>
                </div>
              </div>

            </div>
          )}
          <div style={{ marginTop: "50px" }}>{this.props.children}</div>
        </ImageData>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/Camera.js